exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}._2MtDx77hRPiK3QeaiceIXq{border-radius:1.14286rem;padding-top:.42857rem}._2MtDx77hRPiK3QeaiceIXq hr{width:3.71429rem;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;border-radius:3rem}._2MtDx77hRPiK3QeaiceIXq hr+div{margin-top:.42857rem}._2MtDx77hRPiK3QeaiceIXq .separator hr{width:100%}\n", ""]);

// exports
exports.locals = {
	"mainPackageInfoCard": "_2MtDx77hRPiK3QeaiceIXq"
};